import { Col, Tag, Typography } from 'antd';
import { ProjectsConstructorCard } from '@/components';
import { EmployeeForm } from './EmployeeForm';
import { AddEmployeeDto, EmployeeDto, ProjectDto } from '@/core';
import { useDeleteEmployeeMutation, useUpdateEmployeeMutation } from '@/redux';
import { handleEmployeeData } from './helpers';
import classes from './EmployeeCard.module.scss';

type EmployeeCardProps = EmployeeDto & {
  onClickMenuEdit: () => void;
  isEdit: boolean;
  stopEditCard: (id: string) => void;
  projectData: ProjectDto;
};

const getInitialValue = (
  name: string,
  positionId: string,
  department: string,
  unitManager: string | null,
) => {
  let departmentFormValue = '';
  if (unitManager) {
    departmentFormValue = `${unitManager}_${department}`;
  } else {
    departmentFormValue = `department_${department}`;
  }
  return { name, positionId, department: departmentFormValue };
};

export const EmployeeCard = ({
  name,
  positionName,
  positionId,
  department,
  unitManager,
  isEdit,
  id,
  onClickMenuEdit,
  stopEditCard,
  projectData,
}: EmployeeCardProps) => {
  const [updateEmployee] = useUpdateEmployeeMutation();
  const [deleteEmployee] = useDeleteEmployeeMutation();
  const initialValue = getInitialValue(name, positionId, department, unitManager);

  const submitUpdateEmployee = (employeeData: AddEmployeeDto) => {
    const handledEmployeeData = handleEmployeeData(employeeData);
    updateEmployee({ employeeData: handledEmployeeData, id })
      .unwrap()
      .then(() => stopEditCard(id));
  };
  const onClickMenuDelete = () => deleteEmployee({ id });

  return (
    <ProjectsConstructorCard
      isEdit={isEdit}
      onClickMenuDelete={onClickMenuDelete}
      onClickMenuEdit={onClickMenuEdit}
      editForm={
        <EmployeeForm
          handleCancel={() => stopEditCard(id)}
          handleSubmit={submitUpdateEmployee}
          initialValue={initialValue}
          formUid={name}
          isCancelButton
          projectData={projectData}
        />
      }
    >
      <Col span={8}>
        <Typography.Paragraph className="pe-3">{name}</Typography.Paragraph>
      </Col>
      <Col span={8}>
        <Typography.Paragraph className="pe-3">{positionName}</Typography.Paragraph>
      </Col>
      <Col span={8}>
        <div className={classes.tagsWrapper}>
          <Tag color="blue">
            <Typography.Text ellipsis>{department}</Typography.Text>
          </Tag>
          {unitManager && (
            <Tag color="green">
              <Typography.Text ellipsis>{unitManager}</Typography.Text>
            </Tag>
          )}
        </div>
      </Col>
    </ProjectsConstructorCard>
  );
};
